import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const h = (token) => ({ headers: { 'X-Chat-Token': token } });

export const chatApi = {
  identify: (body) => axios.post(`${API}/chat/identify`, body).then((r) => r.data),
  verify: (body) => axios.post(`${API}/chat/verify`, body).then((r) => r.data),
  documents: (token) => axios.get(`${API}/chat/my-documents`, h(token)).then((r) => r.data),
  emailDoc: (token, id) => axios.post(`${API}/chat/documents/${id}/email`, {}, h(token)).then((r) => r.data),
  checkout: (token, paymentId) => axios.post(`${API}/chat/payments/checkout`, { payment_id: paymentId, origin_url: window.location.origin }, h(token)).then((r) => r.data),
  respondAppt: (token, pid, action, note) => axios.post(`${API}/chat/appointments/${pid}/respond`, { action, note }, h(token)).then((r) => r.data),
  request: (body) => axios.post(`${API}/chat/access-request`, body).then((r) => r.data),
  verifyRequest: (body) => axios.post(`${API}/chat/access-request/verify`, body).then((r) => r.data),
  download: async (token, doc) => {
    const r = await axios.get(`${API}/chat/documents/${doc.id}/download`, { ...h(token), responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = doc.name;
    a.click();
    URL.revokeObjectURL(url);
  },
};

export const errKey = (err) => err?.response?.data?.detail;
